import { GlobalIntegration } from '@omnea-app/config/globalIntegrations'
import { CreditsafeQuestionIdsArray } from './creditsafe'
import { ThomsonReutersQuestionIdsArray } from './thomsonReuters'
import { TprmContinuousMonitoringQuestionIdsArray } from './tprmContinuousIntegration'

export const getProtectedExtOpsQuestionIds = (integration: GlobalIntegration | undefined): string[] => {
  switch (integration) {
    case 'creditsafe':
      return CreditsafeQuestionIdsArray
    case 'thomson-reuters':
      return ThomsonReutersQuestionIdsArray
    case 'tprm-continuous-monitoring':
      return TprmContinuousMonitoringQuestionIdsArray
    default:
      return []
  }
}
